import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import intlTelInput from 'intl-tel-input';
import { UntypedFormControl, ValidationErrors } from '@angular/forms';
import { InputComponent } from '../input/input.component';
import { UtilsService } from '../../../services/utils.service';

@Component({
  selector: 'app-tel-input',
  templateUrl: './tel-input.component.html',
  styleUrls: ['./tel-input.component.scss'],
})
export class TelInputComponent implements AfterViewInit, OnDestroy {
  public iti: intlTelInput.Plugin | undefined;

  @ViewChild('telInput') telInput: InputComponent;

  @Input() public disabled: boolean = false;
  @Input() public fc: UntypedFormControl;
  @Input() public label: string;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.fc?.setValidators([this.validate.bind(this)]);

    this.iti = UtilsService.initIntlTelInput(this.telInput.input.nativeElement);
    this.iti.promise.then(() => this.setupField());
  }

  validate(): ValidationErrors | null {
    if (!this.iti?.isValidNumber()) {
      return {
        invalidPhoneNumber: {
          reason: this.iti?.getValidationError(),
        },
      };
    }

    return null;
  }

  setupField(): void {
    this.iti?.setNumber(this.fc.value);
    this.updateValue();
    this.cdr.detectChanges();
  }

  updateValue(): void {
    this.fc.setValue(
      this.iti?.getNumber(window.intlTelInputUtils.numberFormat.NATIONAL)
    );
  }

  ngOnDestroy(): void {
    this.iti?.destroy();
  }
}
